import React, { useState } from 'react';
import axios from 'axios';
import { navigate } from 'gatsby';
import TypeGrid from '../CommonComponent/TypeGrid';
import Individual from '../../../images/icons/Individual.svg';
import Company from '../../../images/icons/company.svg';
import Proprietorship from '../../../images/icons/Proprietorship.svg';
import './Profession.css';

const Profession = props => {
  const [selectedProfession, setselectedProfession] = useState('');

  function onClickCards(selectedProfession) {
    setselectedProfession(selectedProfession);
  }
  return (
    <div className="basicdetails container w-11/12 mx-auto">
      <h1 className="text-center text-2xl py-5 font-khand text-xl font-semibold">
        Profession
      </h1>
      <div
        className="container_box bg-white  rounded-md shadow py-10 px-4 lg:px-0 sm:mx-auto 
     lg-remove-bgColor sm:mb-48 mb-10"
      >
        <div
          className="grid grid-cols-2 xl:grid-cols-5 gap-10 sm:col-gap-0 sm:row-gap-10
          text-sm"
        >
          <TypeGrid
            profession="Developer"
            image={Proprietorship}
            onClickCards={onClickCards}
            isSelected={selectedProfession === 'Developer'}
          />
          <TypeGrid
            profession="Real Estate Sales"
            image={Proprietorship}
            onClickCards={onClickCards}
            isSelected={selectedProfession === 'Real Estate Sales'}
          />
          <TypeGrid
            profession="Banker/Freelancer"
            image={Proprietorship}
            onClickCards={onClickCards}
            isSelected={selectedProfession === 'Banker/Freelancer'}
          />
          <TypeGrid
            profession="Connector/DSA"
            image={Proprietorship}
            onClickCards={onClickCards}
            isSelected={selectedProfession === 'Connector/DSA'}
          />
          <TypeGrid
            profession="Others"
            image={Proprietorship}
            onClickCards={onClickCards}
            isSelected={selectedProfession === 'Others'}
          />
        </div>

        <div className="btn_box">
          <button
            disabled={selectedProfession ? false : true}
            type={selectedProfession ? 'submit' : 'button'}
            className={`submitButton
               focus:outline-none w-56 md:w-28 ${
                 selectedProfession ? 'cursor-pointer' : 'cursor-not-allowed'
               }`}
          >
            NEXT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profession;
